import React from "react";

const Marquee = ({ items, label }) => {
  const row = (ariaHidden) => (
    <div className="flex items-center shrink-0" aria-hidden={ariaHidden || undefined}>
      {items.map((item, i) => (
        <React.Fragment key={`${item}-${i}`}>
          <span className="font-display text-xl sm:text-2xl text-[#C5CEE0]/80 px-8 sm:px-12 whitespace-nowrap italic">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rotate-45 bg-[#D4AF37]/70 shrink-0" aria-hidden="true" />
        </React.Fragment>
      ))}
    </div>
  );

  return (
    <div className="relative py-10 sm:py-14 border-y border-[#D4AF37]/15 bg-[#0E142B]/60 overflow-hidden">
      {label && (
        <div className="absolute top-3 left-1/2 -translate-x-1/2 z-10">
          <span className="eyebrow text-[10px] bg-[#0B1021] px-4 py-1 border border-[#D4AF37]/25 rounded-full">
            {label}
          </span>
        </div>
      )}
      <div className="flex w-max animate-marquee marquee-paused mt-4" data-testid="press-marquee">
        {row(false)}
        {row(true)}
      </div>
      <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0B1021] to-transparent pointer-events-none" />
      <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0B1021] to-transparent pointer-events-none" />
    </div>
  );
};

export default Marquee;
